<template>
  <notassigned_mr-component>
    <b-row sm="12" style="margin-top: 10px;">             
      <b-col md="3" class="my-1 ">
        <b-form-group>
          <label ><b>Total Cost</b></label>
          <b-input-group prepend="₹" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input :label-cols="3" type="number" name="Cost"  v-model="total_cost" readonly disabled>
            </b-form-input>
                </b-input-group>
        </b-form-group>
       </b-col>

        <b-col md="3" class="my-1 ">
          <b-form-group>
            <label><b>Total Volumetric Weight</b></label>
            <b-input-group >
              <b-form-input :label-cols="3" type="number" name="total_valweight"  v-model="total_valweight" readonly disabled>
              </b-form-input>
              <b-input-group-prepend><b-input-group-text>
                .Kg
                  </b-input-group-text></b-input-group-prepend>
                  </b-input-group>
          </b-form-group>
        </b-col>   

        <b-col md="3" class="my-1 ">
          <b-form-group>
            <label><b>Total Physical Weight</b></label>
            <b-input-group >
              <b-form-input :label-cols="3" type="number" name="total_weight"  v-model="total_weight" readonly disabled>
              </b-form-input>
              <b-input-group-prepend><b-input-group-text>
                .Kg
                  </b-input-group-text></b-input-group-prepend>
                </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="3" class="my-1 ">
          <b-form-group >
            <label><b>Total Box Count</b></label>
            <b-input-group >
              <b-form-input :label-cols="3" type="number" name="total_box"  v-model="total_box" readonly disabled>
              </b-form-input>
              <b-input-group-prepend><b-input-group-text>
                .Qty
                  </b-input-group-text></b-input-group-prepend>
                  </b-input-group>
          </b-form-group>
        </b-col>
    </b-row>
    <br>
    <b-row sm="12"> 
      <b-col md="4" class="my-1">
       
                   <b-form-group label="Assign Vehicle"  :label-cols="4" >
                    
                    <v-select @input="selected_vehicleInfo(customer.vehicle_id)" v-model="customer.vehicle_id" :options="vehicle_items" placeholder="--Select--" :disabled="checkedParentAWB.length==0"></v-select>
                   
                  </b-form-group>
      </b-col> 

      <b-col md="2" class="my-1">
        <b-button :disabled="checkedParentAWB.length==0 || isReadOnly" @click="assignVehicle(customer.vehicle_id)"  class="mr-4" type="submit" size="md" variant="primary">Assign</b-button>
      </b-col>  

      <b-col md="2">
        <b-button v-if="checkedParentAWB.length!=0 && isReadOnly==false"  @click="assignDeliveryMode"  class="mr-4" title="Click to Assign Mode" size="md" variant="primary">Delivery Mode</b-button>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col md="5">
        <b-form-group >
                  
                <b-form-textarea v-model.trim="searching" style="height:100px" placeholder="Type to Search : 1023,Test" @input="checklenght(searching)"></b-form-textarea>
                   
                     
        </b-form-group>
            
      </b-col>

      <b-col md="3">
        <b-form-group>
          <b-input-group>
            <b-form-select  v-model="deliverymodevalues" :options="deliveryoptions"></b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-button :disabled="searching.length == 0 && deliverymodevalues.length==0" @click="searchInLoadManagement()"  size="md" variant="primary">Search</b-button>
        &nbsp;
        <b-button :disabled="searching.length == 0 && deliverymodevalues.length==0" @click="clearSearch()"    size="md" variant="danger">Clear</b-button>
      </b-col>

      <b-col md="2">
        <!-- <a  :href="downlaodloadurl+'page_no='+listingpageno+'&&'+'sysusermasterid='+usersysid+'&&'+'usertype='+usertypeid" target="_blank"><b-button v-b-tooltip.hover title="Download Reports" variant="primary">Download</b-button>
        </a> -->
        <a :href="loadurl" target="_blank" v-if="totalRows>0">
        <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
          </a>
          
      </b-col>
    </b-row>

    <b-row> 
      <b-col sm="12">
         <b-col sm="12">
        <table class="table table-bordered">
        <tr>
                  <td colspan="12" bgcolor="white" style=" font-size:14px;"><span class=""><b>Selected Vehicle Info</b></span></td></tr>
                  <tr >
                    <td colspan="2" bgcolor="white" style="font-size: 12px;"><span class=""><b>Vehicle Name : </b>{{selectedvehiclename}}</span></td>
                    <td colspan="2" bgcolor="white" style="font-size: 12px;"><span class=""><b>Vehicle Plate No : </b>{{selectedPlateno}}</span></td>
                    <td colspan="3" bgcolor="white" style="font-size: 12px;"><span class=""><b>Vehicle Volumetric Weight : </b>{{selectedCapacity}}</span></td>
                    <td colspan="3" bgcolor="white" style="font-size: 12px;"><span class=""><b>Vehicle Physical Weight : </b>{{selectedphysicalweight}}</span></td>
                  </tr>
                </table>
              </b-col>
      </b-col>
    </b-row>

      <b-row>
       <b-col sm="12">
        <b-col sm="12" class="text-right">
            <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
        </b-col> 
        <b-col sm="12" v-if="items.length>0">
            <input type='checkbox' @click='checkAll()' v-model='isCheckAll' > 
            <span > Select All </span>
        </b-col>
       </b-col>
      </b-row>

      <b-row>
      <b-col sm="12"> 
        <b-col sm="12">
      <b-table responsive show-empty :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :filter="filternotassgn"   :sort-direction="sortDirection"    @filtered="onFilterednotassgn"    :outlined="outlined" :busy="isBusy" >
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>  




           <template slot="select" slot-scope="row">
                    <!-- {{languages}} -->
              <b-form-group>
                 <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="row.item.parentawb" @change="multiselectdesign($event,row.item)"  v-model='checkedParentAWB' />
              </b-form-group>
            </template>
            
             <template slot="parentawb" slot-scope="row">
              
               <button v-b-tooltip.hover title="View Details" @click="viewDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                  <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
               
               </button>
                
               </template>
               <template slot="invoicevalue" slot-scope="row">
                <span>&#8377; {{row.item.invoicevalue}}</span>
               </template>
               <template slot="awbphysicalweight" slot-scope="row">
                <span> {{row.item.awbphysicalweight}} {{row.item.unit}}</span>
               </template>
                <template slot="valweight" slot-scope="row">
                <span> {{row.item.valweight}} {{row.item.unit}}</span>
               </template>
          <template slot="mpscount" slot-scope="row">
            <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link"  v-if="row.item.mpscount !=''" >
                  <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
               
               </button>
             
          </template>      
      </b-table> 
    </b-col>
    </b-col>
      </b-row> 

      <b-row>
        <b-col sm="12" class="text-right">
          <p style="margin-top: 15px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
        </b-col> 
        <b-col md="12" class="my-1">
          <paginate     v-model="pageNum"  
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </b-col>     
        
      </b-row>  

      <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
        
        <template slot="default" slot-scope="{ hide }">
        <b-row>
        <b-col sm="12" class="text-right">
          <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
        </b-col> 
        <div style="float: left;">
          <!-- v-if="this.mpstotalRows > 0" -->
          <span class="badge ml-2" 
          style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
          <span class="badge ml-2" 
                  style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
        </div>  
        <b-col sm="12"> 
          <!-- <b-col sm="12"> -->
        <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusymps" >
          <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>  
            <template slot="shippingid" slot-scope="row">
              <span>{{row.item.shippingid}}</span>
              <br>
              <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px; cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
              &nbsp;
              <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">SB</span>
            </template>
          <template slot="mpsvalue" slot-scope="row">
                  <span>&#8377;{{row.item.mpsvalue}}</span>
                </template>
                <template slot="physicalweight" slot-scope="row">
                  <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                </template>
                <template slot="breadth" slot-scope="row">
                  <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                </template>
                <template slot="length" slot-scope="row">
                  <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                </template>
                <template slot="height" slot-scope="row">
                  <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                </template>
              
        </b-table> 
      <!-- </b-col> -->
      </b-col>
      </b-row> 
        <b-row>
        <b-col md="6" class="my-1" v-if="mpstotalRows>10">
          <b-pagination
                v-model="mpscurrentPage"
                :total-rows="mpstotalRows"
                :per-page="mpsperPage"
                class="my-0"
              ></b-pagination>
      
        </b-col> 
      </b-row>
          <div class="col-md-12 pull-right"> 
                  <div slot="footer" class="text-right">
                  
                    <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                  </div>
                </div>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
    
      <b-modal size="xl" title="AWB Details" v-model="awbdetailsmodal" @ok="awbdetailsmodal = false" hide-footer>
        <template slot="default" slot-scope="{ hide }">
          <b-row class="col-md-12" > 
                  
                  <div class="col-md-3">
                    <span><b>Parent Awb :</b></span>&nbsp;
                    <span>{{detailsitem.parentawb}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Category :</b></span>&nbsp;
                    <span>{{detailsitem.category}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Booking Mode :</b></span>&nbsp;
                    <span>{{detailsitem.bookingmode}}</span>
                  </div>
                  <div class="col-md-3">
                    <span><b>Delivery Status :</b></span>&nbsp;
                    <span>{{detailsitem.deliverystatus}} </span>
                    
                  </div>
            </b-row>
            <br>
            <b-row class="col-md-12" > 
              <div class="col-md-3">
                    <span><b>Load ID :</b></span>&nbsp;
                    <span>{{detailsitem.invoiceno}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Invoice Date :</b></span>&nbsp;
                    <span>{{detailsitem.invoicedate}} </span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Invoice Value :</b></span>&nbsp;
                    <span>{{detailsitem.invoicevalue}}</span>
                  </div>
                  <div class="col-md-3">
                    <span><b>Pick Up Date :</b></span>&nbsp;
                    <span>{{detailsitem.pickupdatetime}}</span>
                    
                  </div>
                
            </b-row>
            <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Seller Name :</b></span>&nbsp;
                    <span>{{detailsitem.sellername}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b>Registor No :</b></span>&nbsp;
                    <span>{{detailsitem.sellergstregnumber}} </span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b> Weight :</b></span>&nbsp;
                    <span>{{detailsitem.valweight}} {{detailsitem.unit}}</span>
                    
                  </div>
              
              
                
                  
                  <div class="col-md-3">
                    <span><b>Risk :</b></span>&nbsp;
                    <span>{{detailsitem.risksurcharge}}</span>
                    
                  </div>
                
              
                
            </b-row>
            <br>
            <b-row class="col-md-12" >
              <div class="col-md-3">
                    <span><b>Seller Address :</b></span>&nbsp;
                    <span>{{detailsitem.selleraddress}}</span>
                    
                  </div>
                <div class="col-md-3">
                    <span><b>Seller State :</b></span>&nbsp;
                    <span>{{detailsitem.supplysellerstateplace}}</span>
            </div> 
                  
                  <div class="col-md-3">
                    <span><b>Seller Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.sellerpincode}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Route Mode :</b></span>&nbsp;
                    <span>{{detailsitem.routemode}}</span>
                    
                  </div>
            
            
            </b-row>
                <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Source Company :</b></span>&nbsp;
                    <span>{{detailsitem.sourcecompanyname}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b> Source Mailid :</b></span>&nbsp;
                    <span>{{detailsitem.sourceemailid}} </span>
                    
                  </div>
                  
              <div class="col-md-3">
                    <span><b>Source Mobile No :</b></span>&nbsp;
                    <span>{{detailsitem.sourcemobileno}}</span>
                    
                  </div>
                
                  
                  <div class="col-md-3">
                    <span><b>Source Type :</b></span>&nbsp;
                    <span>{{detailsitem.sourcetype}}</span>
                    
                  </div>
                
            </b-row>
              <br>
            <b-row class="col-md-12" >
          
            <div class="col-md-3">
                    <span><b> Source Address :</b></span>&nbsp;
                    <span>{{detailsitem.sourceaddress}} </span>
                    
                  </div>
                  
              <div class="col-md-3">
                    <span><b>Source City :</b></span>&nbsp;
                    <span>{{detailsitem.sourcecity}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Source State :</b></span>&nbsp;
                    <span>{{detailsitem.sourcestate}}</span>
            </div> 
                  
                  <div class="col-md-3">
                    <span><b>Source Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.sourcepincode}}</span>
                    
                  </div>
                
            </b-row>
                  <br>
            <b-row class="col-md-12" >
            <div class="col-md-3">
                    <span><b>Destination Company :</b></span>&nbsp;
                    <span>{{detailsitem.destinationcompanyname}}</span>
            </div> 
            <div class="col-md-3">
                    <span><b>Mail Id :</b></span>&nbsp;
                    <span>{{detailsitem.destinationemailid}} </span>
                    
                  </div>
                  
              <div class="col-md-3">
                    <span><b>Destination Mobile No :</b></span>&nbsp;
                    <span>{{detailsitem.destinationmobileno}}</span>
                    
                  </div>
                
                  
                  <div class="col-md-3">
                    <span><b>Destination Poc Name :</b></span>&nbsp;
                    <span>{{detailsitem.destinationspocpersonname}}</span>
                    
                  </div>
                
            </b-row>
              <br>
            <b-row class="col-md-12" >
          
            <div class="col-md-3">
                    <span><b> Destination Address :</b></span>&nbsp;
                    <span>{{detailsitem.destinationaddress}} </span>
                    
                  </div>
                  
              <div class="col-md-3">
                    <span><b>Destination City :</b></span>&nbsp;
                    <span>{{detailsitem.destinationcity}}</span>
                    
                  </div>
                  <div class="col-md-3">
                    <span><b>Destination State :</b></span>&nbsp;
                    <span>{{detailsitem.destinationstate}}</span>
            </div> 
                  
                  <div class="col-md-3">
                    <span><b>Destination Pincode :</b></span>&nbsp;
                    <span>{{detailsitem.destinationpincode}}</span>
                    
                  </div>
                  <div class="col-md-12 pull-right"> 
                  <div slot="footer" class="text-right">
                  
                    <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                  </div>
                </div>
                
            </b-row>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>

      <b-modal size="md" title="Assign Delivery Mode" v-model="modeModal" @ok="modeModal = false" hide-footer>
        <template slot="default" slot-scope="{ hide }">
          <div>
            <b-form-group label="Please Check to Assign Delivey Mode" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="radio-group-1"
                v-model="selectedCheckbox"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
            <!-- {{selectedCheckbox}} -->
          </div>
          <div>
            <footer class="column has-text-right" v-if="selectedCheckbox=='direct'">
            <b-button variant="primary" size="md"  @click="directMode()">Submit</b-button>
            </footer>
          </div>
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
          <b-row>
            <b-col sm='12' v-if="selectedCheckbox=='hubtohub'">
              <b-form-group>
                          <label for="hub">Select Hub</label>
                            <b-form-select  v-model="selectedHub" name="hub" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.hub') }">
                            <option value="">-- Select Hub --</option>
                            <option :value="hub.hubid" v-for="hub in hubListing"  :key="hub.hubid" >
                              {{hub.hubname}} - {{hub.hubid}}
                          </option>
                            <!-- <option v-for="(list in hubListing)">{{list}}</option>    -->
                            <!-- <option value="4">Sub Coordinator</option>            -->
                          </b-form-select>
                        
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.hub')" >{{ errors.first('form-1.hub') }}</i>

                        </span>
                        
                        </b-input-group>
                    </b-form-group>

            </b-col>
          </b-row>
          <footer class="column has-text-right" v-if="selectedCheckbox=='hubtohub'">
            <b-button variant="primary" size="md"  type="submit">Submit</b-button>
            </footer>
            <div id="overlayModal" >
            <div class="loaderModal"></div>
            </div>
          </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>

      <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
        <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
          No Record Found
        </div>
        <div v-else class="text-center">
          <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
        </div>
      </b-modal>

  
  </notassigned_mr-component>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      assigned:[],
      items:[],
      
      isBusy: false,
       fields: [
      { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
      // { key: 'consignmentmasterid', label: 'Vehicle Id', sortable: true, sortDirection: 'desc' },
        { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
          { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
          { key: 'warehouseid', label:'WareHouse ID', sortable: true, sortDirection: 'desc' },
           { key: 'invoicevalue', label: 'Invoice Value', sortable: true,class:'invoicevalue'},
           { key: 'valweight', label: 'Volumetric Weight', sortable: true,class:'valweight'},
          { key: 'awbphysicalweight', label: 'Physical Weight', sortable: true,class:'physicalweight'},
          
         { key: 'mpscount', label: 'MPS Count', sortable: true},
          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true },
         { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
          { key: 'delivery_mode', label: 'Delivery Mode', sortable: true},
          { key: 'custvendorname', label: 'WareHouse Name', sortable: true},
          { key: 'destinationaddress', label: 'Destination Address', sortable: true},
          // { key: 'userinfo', label: 'SR Name', sortable: true},
          // { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},               
          { key: 'createddate', label: 'Created Date', sortable: true },

          // { key: 'actions', label: 'Actions' },
      ],
      productdetailsModal:false,
      awbdetailsmodal:false,
   
      mpsfields:[
        // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
        { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
        { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
        
        { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
        { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
          
          { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
        { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
        // { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
          
      ],
       checkedvehicle:[],
       selectedvehicle:[],
      selectedvehicleid_length:0,
      selectedvehicleid:[],
      selected_options:[],
      selected_weight:[],
      selected_id:[],
      selected_cost:[],
      outlined: true,
      isCheckAll:false,
      totalRows: 0,
      assigntotalRows:0,
      currentPage: 1,
      perPage:  60,
      pageOptions: [5, 10, 15],
      filternotassgn:null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selected_vehicleid:'',
      total_weight:0,
      total_box:0,
      total_cost:0,
      total_valweight:0,
      selected_count:[],
      selected_valweight:[],
      detailsitem:'',
      vehicleitems:[],
      vehicle_items:[],
      customer:{},
      selectedCapacity:'',
      selectedvehiclename:'',
      selectedphysicalweight:'',
      selectedPlateno:'',
      mpsitems:[],
      isBusymps : false,
      mpscurrentPage:1,
      mpsperPage:10,
     mpstotalRows:0,
     searching:[],
     searchvaluesarr:[],
     noofpages:'',
     pageNum:1,
     listingpageno :1,
     checkedParentAWB:[],
     checkedItem:[],
     invoicevalue:[],
     awbphysicalweight:[],
     valweight:[],
     mpscount:[],
     modeModal:false,
     selectedCheckbox:'',
     options: [
          { text: 'Direct Delivery', value: 'direct' },
          { text: 'HubtoHub Delivery', value: 'hubtohub' },
          
        ],
        hubListing:[],
        selectedHub:'',
     infoModal: {
          id: 'info-modal',
          title: '',
          content: '',
          data:''
      },
      deliverymodevalues: '',
        deliveryoptions: [
          { value: "", text: 'Please select an option' },
          { value: 'Hub_To_Hub', text: 'Hub_To_Hub' },
          { value: 'Direct', text: 'Direct' },
        ],
        deliverymodeArr:[],
        arrayvalues:[],
        usertypeid:'',
        usersysid:'',
        loadurl:'',
        selected_user_details :'',
        accessBody:[],
        isReadOnly:false,
    }
  },
   computed: {
    },
    props:["route_id"],
  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.usertypeid=userInfo.user_type;
    this.accessBody = userInfo.body;
    this.ischeckbodyvalidation();
    this.displaydata()
    this.getAssignedShipment(this.pageNum)

  },

  methods: {
    ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        if (element.title=='Load Management' && element.isReadonly==true && this.route_id=='normal') {
          this.isReadOnly=true
        }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='Load Management' && k.isReadonly==true && this.route_id=='asn') {
            this.isReadOnly=true
          }
        }
       }
      }
    },
    checklenght(value){
      console.log("value",value)
      if (value.length==0) {
        this.searching=[]
        this.totalRows=0
        this.searchvaluesarr=[]
        this.getAssignedShipment(this.pageNum)
      }
    },
      downlaodloadurl(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
          if (this.searchvaluesarr.length>0) {
            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`NotAssigned`+`&&`+`payloadArr=`+this.searchvaluesarr+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')

          console.log("this.loadurl",this.loadurl)
          } else {
            this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=`+this.listingpageno+`&&`+`sysusermasterid=`+userInfo.sysusermasterid+`&&`+`usertype=`+userInfo.user_type+`&&`+`for_status=`+`NotAssigned`+`&&`+`is_asn=`+(this.route_id == 'normal' ? 'NO': 'YES')

          console.log("this.loadurl",this.loadurl)
          }
      },

      info(item, index, button) {
        this.infoModal.content = JSON.stringify(item, null, 2);
        //JSON.parse(JSON.stringify(item, null, 2))
        this.infoModal.data = item;
        this.infoModal.title = 'Not Assigned';
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },

      clickCallback(pageNum){
        // alert("ok")
        this.listingpageno = pageNum;
        console.log("pageNum",this.listingpageno)

        this.getAssignedShipment(pageNum);
      },

      resetInfoModal() {
        this.infoModal.title = '',
        this.infoModal.content = '',
        this.infoModal.data = ''
      },

      onFilterednotassgn(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1
      },

      checkAll: function(){

        this.isCheckAll = !this.isCheckAll;
        this.invoicevalue=[];
        this.awbphysicalweight=[];
        this.valweight=[]
        this.mpscount=[];
        this.total_cost=0;
        this.total_weight=0;
        this.total_box=0;
        this.total_valweight=0;
        this.checkedParentAWB=[];
        // this.total_cost=0;
        //    this.total_weight=0;
        //    this.total_box=0;
        //    this.total_valweight=0;
        // console.log(this.items[0].shippingid);
        if(this.isCheckAll){ // Check all
          // alert("isCheckAll");
          for (var key in this.items) {
            this.checkedParentAWB.push(this.items[key].parentawb);
            // console.log("this.checkedParentAWB",this.checkedParentAWB);
            this.invoicevalue.push(this.items[key].invoicevalue);
            // console.log("this.invoicevalue",this.invoicevalue);
            this.awbphysicalweight.push(this.items[key].awbphysicalweight);
            // console.log("this.awbphysicalweight",this.awbphysicalweight);
            this.valweight.push(this.items[key].valweight);
            // console.log("this.valweight",this.valweight);
            this.mpscount.push(this.items[key].mpscount);
            // console.log("this.mpscount",this.mpscount);
            // this.checkedItem.push(this.items[key])
          }
           this.checkAllCal(this.invoicevalue,this.awbphysicalweight,this.valweight,this.mpscount);
        }else{
           this.total_cost=0;
           this.total_weight=0;
           this.total_box=0;
           this.total_valweight=0;
           this.customer={};
           this.selectedvehiclename='';
           this.selectedPlateno='';
           this.selectedCapacity='';
           this.selectedphysicalweight='';
        }
      },

      checkAllCal(invoicevalue,awbphysicalweight,valweight,mpscount){
      
       for(let i=0;i<this.items.length;i++){
        
        this.total_cost=this.formatPrice((parseFloat(this.total_cost)+parseFloat(invoicevalue[i])));
        
        this.total_weight = this.formatPrice((parseFloat(this.total_weight)+parseFloat(awbphysicalweight[i])));
        
        this.total_box=this.formatPrice((parseInt(this.total_box)+parseInt(mpscount[i])));
       
        this.total_valweight=this.formatPrice((parseFloat(this.total_valweight)+parseFloat(valweight[i])));
      
       }
    
      },

      updateCheckall: function(){
      
        if(this.checkedParentAWB.length == this.items.length){
          // alert("ifff");
           this.isCheckAll = true;
        }else{
          // alert("else");
           this.isCheckAll = false;

        }
      },

      multiselectdesign(e,value){
      
        if (this.checkedParentAWB.length >=0)

        {
        // this.isCheckAll = true;
          this.selected_weight=value.awbphysicalweight;
         
           this.selected_cost=value.invoicevalue;
         
          this.selected_count=value.mpscount;
          
          this.selected_valweight=value.valweight;
          if (e.target.checked==true){
            this.total_weight = this.formatPrice((parseFloat(this.total_weight)+parseFloat(this.selected_weight)));
             
             this.total_cost=this.formatPrice((parseFloat(this.total_cost)+parseFloat(this.selected_cost)));
             
              this.total_box=this.formatPrice((parseInt(this.total_box)+parseInt(this.selected_count)));
            
              this.total_valweight=this.formatPrice((parseFloat(this.total_valweight)+parseFloat(this.selected_valweight)));
            if(this.checkedParentAWB.length == this.items.length){
          
             this.isCheckAll = true;
             }
            
          }else{
            this.total_weight = this.formatPrice((parseFloat(this.total_weight)-parseFloat(this.selected_weight)));
            
             this.total_cost=this.formatPrice((parseFloat(this.total_cost)-parseFloat(this.selected_cost)));
             
              this.total_box=this.formatPrice((parseInt(this.total_box)-parseInt(this.selected_count)));
              
              this.total_valweight=this.formatPrice((parseFloat(this.total_valweight)-parseFloat(this.selected_valweight)));
            if(this.checkedParentAWB.length == 0){
          
             this.isCheckAll = false;
             }  
          }


        }
       

      },
 
      viewProduct:function(value){
        this.mpscurrentPage=1;
        this.productdetailsModal=true;
        this.isBusymps = true;
        console.log("value",value);
       let userData = localStorage.getItem('userData');
      let userInfo = JSON.parse(userData);
     
      
       
      let obj = {
        parentawb: value.parentawb,
      }
      this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
          .then(result => {
            console.log("TTTTT",result);
              this.isBusymps = false;
              if(result.body.returnmsg === "successful"){
               
               this.mpsitems  = result.body.returnvalue;
               // console.log("HHHHH",this.mpsitems);
                this.mpstotalRows = result.body.returnvalue.length
                // console.log("RRRRR",this.mpstotalRows);
               
              }else {
               this.mpsitems  = [];
               this.mpstotalRows = 0
              }
          }).catch(ex => {
            console.log('error', ex)
          })
        
      },

      modalCancel:function(){
        this.productdetailsModal=false;
      },

      viewDetails:function(value){
         console.log("value",value);

        this.awbdetailsmodal=true;
        this.detailsitem=value;
      },

      detailsCancel:function(){
        this.awbdetailsmodal=false;
      },

      getAssignedShipment(pageNo){
        // console.log("Test",pageNo);
        this.isBusy = true;
        this.selectedvehicle=[];
        this.items=[];
        this.totalRows = 0;
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
        let pincode=JSON.stringify(userInfo.pickuplocationpincode);
        let obj = {
          for_status: "NotAssigned",
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          payloadArr:this.searchvaluesarr,
          page_no:`${pageNo}`,
          is_asn: this.route_id == 'normal' ? 'NO': 'YES',
        }
        console.log("Obje",obj);
        this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getAllocatedLoadsListing`,obj)
            .then(result => {
              console.log(result.body);
                this.isBusy =false;
                if(result.body.returnmsg === "successful"){
                this.items  = result.body.returnvalue;
                console.log("this.items",this.items);
                
                this.totalRows = result.body.totalcount;  
                this.noofpages=parseInt(this.totalRows)/60;
                this.noofpages=Math.ceil( this.noofpages);
                }else {
                  this.items=[];
                  this.totalRows = 0;
                  // console.log("RRRRRTTTT",this.totalRows);
                }
            }).catch(ex => {
              console.log('error', ex)
            })
      },

      displaydata: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const deliveryagentobj = {
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          isactive:'1',
        };
        console.log('deliveryagentobj',deliveryagentobj);
        this.$http
          .post(
            `${
              CONSTANTS.MIGRATION_API_URL
            }/getVehicleListing`,
            deliveryagentobj
          )
          .then(result => {
            console.log("YYY",result);
            if (result.body.length > 0) {
              // this.isBusy = !this.isBusy
              this.data = result.body;
              this.vehicleitems  = result.body;
              for (let i = 0; i <  this.vehicleitems.length; i++) {
                var vehicle_idDetails =  this.vehicleitems[i].vehicle_no + "-" +  this.vehicleitems[i].vehicle_id + "-" +  this.vehicleitems[i].vehicle_name;
                this.vehicle_items.push(vehicle_idDetails)
              }
              // console.log("okkkk",this.vehicle_items)
            
            } else {
            
              this.data = result.body;
              this.vehicleitems  = result.body;
              
            }
          })
          .catch(ex => {
            console.log("error", ex);
          });
      
      },
    
      selected_vehicleInfo:function(value){
          if (value==null) {
            this.checkedParentAWB = [];
          }
          else {
            var vehicle_idDetails = value.split("-");
            value = vehicle_idDetails[1];
            console.log("Value",value)
            for(var i=0;i<this.vehicleitems.length;i++){
            if(value==this.vehicleitems[i].vehicle_id){
              this.selectedvehiclename=this.vehicleitems[i].vehicle_name;
              // this.vehicleitems[i].vehicleno_prefix + ' ' + 
              this.selectedPlateno=this.vehicleitems[i].vehicle_no;
              this.selectedCapacity=this.vehicleitems[i].vehicleweightcarrying;
              console.log("GG",this.selectedCapacity);
              this.selectedphysicalweight=this.vehicleitems[i].vehiclephysicalweight;
            }
          }
          }
      },

      assignVehicle:function(value){
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var vehicle_idDetails = value.split("-");
            value = vehicle_idDetails[1];

            this.selected_vehicleid=value;
            if(this.selected_vehicleid !='' && this.selected_vehicleid != undefined){
              for(var i=0;i<this.vehicleitems.length;i++){
                if(value==this.vehicleitems[i].vehicle_id){
                  this.selectedvehiclename=this.vehicleitems[i].vehicle_name;
                  this.selectedCapacity=this.vehicleitems[i].vehicleweightcarrying;
                  this.selectedphysicalweight=this.vehicleitems[i].vehiclephysicalweight;
      // ;            console.log("selectedCapacity",this.selectedCapacity);
                }
              }
              if(parseFloat(this.selectedphysicalweight)>=parseFloat(this.total_weight) && parseFloat(this.selectedCapacity)>=parseFloat(this.total_valweight)){
              var selectAwb = document.getElementsByClassName('parentAWBcheckbox');

            var selectedparentAWB=[];
            var assignobj={};
          // console.log("length:"+selectShipment.length);
              if(selectAwb.length>0)
              {
                for (var i = 0; i < selectAwb.length; i++) {
                    if (selectAwb[i].checked == true){
                      selectedparentAWB.push(selectAwb[i].value)
                      // console.log("Sllll",shippingIds);
                    }
                }
              }
              assignobj.parent_awb=selectedparentAWB;
              assignobj.vehicle_id=this.selected_vehicleid;
              assignobj.lastmodifiedby=`${userInfo.userfirstname}` + ' ' + `${userInfo.userlastname}`

            console.log("assignobj",assignobj);
            // return false;
            this.$http
                    .post(
                      `${
                        CONSTANTS.MIGRATION_API_URL
                      }/allocateLoadToVehicle`,
                      assignobj
                    )
                    .then(result => {
                  console.log(result);
                  document.getElementById("overlay").style.display = "none";
                      if (result.body.returnmsg === "Successful") {


                      
                        this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                      }); 
                        this.customer={};
                        this.selectedvehicle=[];
                        this.selectedoption='';
                        this.selected_vehicleid='';
                        this.total_weight=0;
                        this.total_cost=0;
                        this.total_valweight=0;
                        this.total_box=0;
                        this.checkedvehicle=[];   
                        this.selectedvehicle.length=0;
                        this.selectedvehiclename='';
                        this.selectedPlateno='';
                        this.selectedCapacity='';
                        this.selectedphysicalweight='';
                        this.invoicevalue=[];
                        this.awbphysicalweight=[];
                        this.valweight=[]
                        this.mpscount=[];
                        this.checkedParentAWB=[];
                        this.searching=[];
                        this.searchvaluesarr=[];
                        this.deliverymodevalues=[];
                        this.deliverymodeArr=[];
                        this.isCheckAll=false;

                        this.displaydata();

                        this.getAssignedShipment(this.pageNum);
                      
                      
                        
                      
                      } else{
                      
                        this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000
                      }); 
                    

                      }
                    })
                    .catch(ex => {
                      console.log("error", ex);
                    });
          }else{
            document.getElementById("overlay").style.display = "none";
            this.$fire({
                        text: "Total Volumetric & Physical Weight must be less than equal to Vehicle Volumetric & Physical Weight",
                        type: "warning",
                        timer: 30000
                      }); 
          }
          
          }else{
            document.getElementById("overlay").style.display = "none";
            this.$fire({
                        text: "Please Select Vehicle",
                        type: "warning",
                        timer: 30000
                      }); 
          }
      },

      searchInLoadManagement(){
        
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
        if (this.searching && this.deliverymodevalues=="") {
              var searchvalues=[];
              this.searchvaluesarr=[];
              // searchvalues = this.searching.split(',')
              searchvalues = this.searching.split(/[','|' '|'\n']/)
              for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
              }
              console.log("YYY",this.searchvaluesarr)
          } 
          else if(this.searching =="" && this.deliverymodevalues!=""){
            var filtervalues=[];
            this.searchvaluesarr=[];
            filtervalues = this.deliverymodevalues.split(',')
            for (var i = 0; i < filtervalues.length; i++) {
              this.searchvaluesarr.push(`${filtervalues[i]}`)
            }
            console.log("this.deliverymodeArr)",this.deliverymodeArr)
          }
          else if(this.searching && this.deliverymodevalues){
            var searchvalues=[];
              this.searchvaluesarr=[];
              // searchvalues = this.searching.split(',')
              searchvalues = this.searching.split(/[','|' '|'\n']/)
              for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
                console.log("this.searchvaluesarr",this.searchvaluesarr)
              }
            
              var filtervalues=[];
            this.deliverymodeArr=[];
            filtervalues = this.deliverymodevalues.split(',')
            for (var i = 0; i < filtervalues.length; i++) {
              this.deliverymodeArr.push(`${filtervalues[i]}`)
            }
          console.log("this.deliverymodeArr",this.deliverymodeArr)
          this.searchvaluesarr = this.searchvaluesarr.concat(this.deliverymodeArr); 
          console.log("this.arrayvalues",this.searchvaluesarr)
          }
        this.getAssignedShipment(this.pageNum)
        
      },

      assignDeliveryMode(){
        this.selectedCheckbox='';
        this.selectedHub='';
        this.hubDataList();
        this.modeModal=true;

      },
      
      clearSearch(){
        this.searching=[];
        this.searchvaluesarr=[];
        this.customer={};
        this.selectedvehiclename='';
        this.selectedPlateno='';
        this.selectedCapacity='';
        this.selectedphysicalweight='';
        this.total_cost=0;
        this.total_weight=0;
        this.total_box=0;
        this.total_valweight=0;
        this.checkedParentAWB = [];
        this.invoicevalue=[];
        this.awbphysicalweight=[];
        this.valweight=[]
        this.mpscount=[];
        
        this.isCheckAll=false;
        this.deliverymodevalues=[];
          this.deliverymodeArr=[];
        this.getAssignedShipment(this.pageNum)
      },

      hubDataList(){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          
          const Obj={
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`,
          }
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,Obj).then((result)=>{
              // console.log("Result",result);
              
              if (result.body.returnmsg === 'Successful') {
                this.hubListing=result.body.returnvalue;
                // this.actionfun(this.selected_status);
                // this.totalRows=result.body.returnvalue.length;
              }else{
                this.hubListing=[];
                // this.totalRows=0;
              }
          })
      },

      validateForm(scope) {
        this.$validator.validateAll(scope).then(result => {
          if(result){
            this.addHubtoHubMode();
          }
        })
      },

      addHubtoHubMode(){
        document.getElementById("overlayModal").style.display = "block";       
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        
        const Obj={
          hubid:this.selectedHub,
          deliverymode:'Hub_To_Hub',
          allparentawbs:this.checkedParentAWB,
        }
        console.log("Obj",Obj);
        // return false
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateDeliveryModeOfLoads`,Obj).then((result)=>{
            // console.log("Result",result);
           document.getElementById("overlayModal").style.display = "none"; 
            if (result.body.returnmsg === 'Successful') {
              this.$fire({
                  text:result.body.returnvalue,
                  type: "success",
                  timer: 30000
                });
              this.modeModal=false;
              this.selectedCheckbox='';
              this.selectedHub='';
              this.checkedParentAWB=[];
              this.searching=[];
              this.customer={};
              this.selectedvehicle=[];
              this.selectedoption='';
              this.selected_vehicleid='';
              this.total_weight=0;
              this.total_cost=0;
              this.total_valweight=0;
              this.total_box=0;
              this.checkedvehicle=[];   
              this.selectedvehicle.length=0;
              this.selectedvehiclename='';
              this.selectedPlateno='';
              this.selectedCapacity='';
              this.selectedphysicalweight='';
              this.invoicevalue=[];
              this.awbphysicalweight=[];
              this.valweight=[]
              this.mpscount=[];
              this.searching=[];
              this.searchvaluesarr=[];
              this.deliverymodevalues=[];
              this.deliverymodeArr=[];
              this.displaydata();
              this.getAssignedShipment(this.pageNum);
            }else{
              this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                });
            }
        })
         // console.log("addHubtoHubMode",this.checkedParentAWB);
      },

      directMode(){
         document.getElementById("overlayModal").style.display = "block";       
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        
        const Obj={
          hubid:'',
          deliverymode:'Direct',
          allparentawbs:this.checkedParentAWB,
        }
        console.log("Obj",Obj);
        // return false
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateDeliveryModeOfLoads`,Obj).then((result)=>{
            // console.log("Result",result);
           document.getElementById("overlayModal").style.display = "none"; 
            if (result.body.returnmsg === 'Successful') {
              this.$fire({
                  text:result.body.returnvalue,
                  type: "success",
                  timer: 30000
                });
              this.modeModal=false;
              this.selectedCheckbox='';
              // this.selectedHub='';
              this.checkedParentAWB=[];
              this.searching=[];
              this.displaydata();
              this.getAssignedShipment(this.pageNum);
            }else{
              this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                });
            }
        })
      },

      formatPrice(value) {
     
         let val = (value/1).toFixed(2).replace('.', '.')
         return val.toString().replace(/\B(?=(\d{6})+(?!\d))/g, ".")
      },

      Viewimagedetails : function (data){
            this.selected_user_details=data;
            console.log("rrrrrrrrrrr",this.selected_user_details);
      },
  }
};
</script>
<style>
/*.invoicevalue{
  width: 105px !important;
}
.physicalweight{
  width: 80px;
}*/
  
</style>
